import React from 'react'
import { Swiper, Pagination, Autoplay } from 'swiper/js/swiper.esm';
import ReactIdSwiperCustom from 'react-id-swiper/lib/ReactIdSwiper.custom';
import 'swiper/css/swiper.css';
import styles from './swiper-carousel.module.css'

const SwiperCarousel = ({ children, ...props }) => {
  const params = {
    Swiper,
    modules: [ Pagination, Autoplay ],
    freeMode: true,
    slidesPerView: 'auto',
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      bulletClass: 'bullet',
      bulletActiveClass: 'active',
      renderBullet: (index, className) => {
        return `<span class="${className}"><span></span></span>`
      }
    }
  }

  const swiperOptions = {
    ...params,
    ...props
  }

  return (
    <div className={styles['swiper-carousel']}>
      <ReactIdSwiperCustom {...swiperOptions}>
        { children }
      </ReactIdSwiperCustom>
    </div>
  )
}

export { SwiperCarousel }
